export default __webpack_public_path__ + "static/Microbiome_Animation_Optimised-8872ada8409c1b4d164c0a235d8ea51d.mp4";